'use client';

import { useState, useCallback } from 'react';

const STORAGE_KEY = 'hms-wishlist';

function readWishlist(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeWishlist(ids: string[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    /* storage full or unavailable */
  }
}

export function useWishlist() {
  const [savedIds, setSavedIds] = useState<string[]>(readWishlist);

  const isSaved = useCallback((id: string) => savedIds.includes(id), [savedIds]);

  const toggleSave = useCallback((id: string) => {
    setSavedIds((prev) => {
      const next = prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id];
      writeWishlist(next);
      return next;
    });
  }, []);

  return { savedIds, isSaved, toggleSave };
}
